import {Button, Stack, Typography} from "@mui/joy";
import React from "react";
import {BarChart3, BookOpen, GaugeIcon} from "lucide-react";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {appRoute} from "../../utils/routes";
import EmptyResultsIllustration from "../Illustrations/EmptyResultsIllustration";

const NoResultsComponent = () => {
    const {t} = useTranslation()

    return <Stack width={"100%"} paddingY={1.5} alignItems={"center"} gap={1.5}>
        <EmptyResultsIllustration />
        <Typography level={"h3"}>
            {t("noResultsTitle")}
        </Typography>
        <Typography level={"title-lg"} maxWidth={"60%"} fontWeight={"normal"} textAlign={"center"}>
            {t("noResultsDescription")}
        </Typography>
        <Button fullWidth size={"lg"} component={Link} to={appRoute("practice")}
                sx={{maxWidth: "30%"}}>
            {t("noResultsActionLabel")}
        </Button>
    </Stack>
}

export default NoResultsComponent